import React, { useState } from "react";

/**
 * Button — Primary (dark green) or secondary (Google-style white) button.
 */
export default function Button({
  variant = "primary",
  children,
  onClick,
  disabled = false,
  loading = false,
  type = "button",
  icon,
  ...rest
}) {
  const [hovered, setHovered] = useState(false);
  const isPrimary = variant === "primary";

  const bgColor = isPrimary
    ? disabled
      ? "#8b8b8b"
      : hovered
      ? "#374151"
      : "#1f2937"
    : hovered
    ? "#f3f4f6"
    : "#ffffff";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        ...styles.base,
        backgroundColor: bgColor,
        color: isPrimary ? "#ffffff" : "#3a3a3a",
        border: isPrimary ? "none" : "1px solid #e5e7eb",
        cursor: disabled || loading ? "not-allowed" : "pointer",
        opacity: disabled ? 0.7 : 1,
      }}
      {...rest}
    >
      {loading ? (
        <span
          style={{
            display: "inline-block",
            width: 16,
            height: 16,
            border: `2px solid ${isPrimary ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.15)"}`,
            borderTopColor: isPrimary ? "#ffffff" : "#545454",
            borderRadius: "50%",
            animation: "spin 0.6s linear infinite",
          }}
        />
      ) : (
        <>
          {icon && <span style={{ flexShrink: 0, display: "flex", alignItems: "center" }}>{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
}

const styles = {
  base: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    padding: "11px 16px",
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "'Inter', sans-serif",
    transition: "background-color 0.15s, box-shadow 0.15s",
    boxSizing: "border-box",
  },
};
